import { createCanBoundTo } from '@casl/react';
const { Ability } = require( '@casl/ability' );

export const generateCan = ( abilities ) => {
    const ability = new Ability( abilities );

    return { Can: createCanBoundTo( ability ), abilities: ability };
};
